<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <Mlogin />
          <DocumentsNewsBlockControl />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">{{ title }}</div>
                  <div class="title_more2">
                    <a href="/">首页</a>>{{ title }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container" v-html="Body"></div>
              </div>
            </div>
          </el-col>
          
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      title: '',
      Body: '',
    }
  },
  components: {},
  mounted() {
    this.id = this.$route.query.ItemId
    this.GetList()
  },
  watch: {
    $route(to, from) {
      if (to.query.ItemId !== from.query.ItemId) {
        this.id = to.query.ItemId
        this.GetList()
      }
    },
  },
  methods: {
    GetList() {
      this.$store.dispatch('_getHeader', [parseInt(this.id)]).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.title = res.data.Data[0].Title
            document.title = this.title
            this.DataType = res.data.Data[0].DataType
            if (this.DataType === 'Link') {
              this.$router.go(-1)
              window.open(res.data.Data[0].Body, '_blank')
            } else if (this.DataType === 'File') {
              this.OpenGUIDFile(res.data.Data[0].Body)
              this.$router.go(-1)
            } else if (this.DataType === 'Text') {
              this.Body = res.data.Data[0].Body
            }
          }
        }
      })
    },
    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch('_OpenGUIDFile', {
          FileGUID: FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1)
          } else {
            this.$error(res.data.Message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
